// extracted by mini-css-extract-plugin
export default {"tab_container":"AppTabContainer_tab_container__pbHaA","image":"AppTabContainer_image__BCagm"};